module.exports = __webpack_public_path__ + "static/profile-1c5a406322ceb7f8624a8e387f070bc2.png";